import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
  nroManutencao?: number | null;
  idsMaquinaEquip?: number[] | null;
  idsCentroCusto?: number[] | null;
  idsFuncionarioSolicitante?: number[] | null;
  idsFuncionarioAprovacao?: number[] | null;
  idsFornecedorResponsavel?: number[] | null;
  dataSolicitacaoDe?: Date | null;
  dataSolicitacaoAte?: Date | null;
  status?: number[] | null;
};

type Action = {
  setNroManutencao: (nroManutencao: number | null) => void,
  setIdsMaquinaEquip: (ids: number[] | null) => void,
  setIdsFuncionarioSolicitante: (ids: number[] | null) => void,
  setIdsFuncionarioAprovacao: (ids: number[] | null) => void,
  setIdsCentroCusto: (ids: number[] | null) => void,
  setIdsFornecedorResponsavel: (ids: number[] | null) => void,
  setDataSolicitacaoDe: (date: Date | null) => void,
  setDataSolicitacaoAte: (date: Date | null) => void,
  setStatus: (status: number[] | null) => void,
  clearFilters: () => void
};

export const useManutencaoSolicitacaoFilters = create<State & Action>((set) => ({
  nroManutencao: null,
  idsMaquinaEquip: null,
  idsCentroCusto: null,
  idsFuncionarioSolicitante: null,
  idsFuncionarioAprovacao: null,
  idsFornecedorResponsavel: null,
  dataSolicitacaoDe: null,
  dataSolicitacaoAte: null,
  status: null,
  setNroManutencao: (nroManutencao) => set({ nroManutencao }),
  setIdsMaquinaEquip: (idsMaquinaEquip) => set({ idsMaquinaEquip }),
  setIdsFuncionarioSolicitante: (idsFuncionarioSolicitante) => set({ idsFuncionarioSolicitante }),
  setIdsFuncionarioAprovacao: (idsFuncionarioAprovacao) => set({ idsFuncionarioAprovacao }),
  setIdsCentroCusto: (idsCentroCusto) => set({ idsCentroCusto }),
  setIdsFornecedorResponsavel: (idsFornecedorResponsavel) => set({ idsFornecedorResponsavel }),
  setDataSolicitacaoDe: (dataSolicitacaoDe) => set({ dataSolicitacaoDe }),
  setDataSolicitacaoAte: (dataSolicitacaoAte) => set({ dataSolicitacaoAte }),
  setStatus: (status) => set({ status }),
  clearFilters: () => set({
    nroManutencao: null,
    idsMaquinaEquip: null,
    idsCentroCusto: null,
    idsFuncionarioSolicitante: null,
    idsFuncionarioAprovacao: null,
    idsFornecedorResponsavel: null,
    dataSolicitacaoDe: null,
    dataSolicitacaoAte: null,
    status: null,
  }),
}));

export const initialFiltersValues: State = {
  nroManutencao: null,
  idsMaquinaEquip: null,
  idsCentroCusto: null,
  idsFuncionarioSolicitante: null,
  idsFuncionarioAprovacao: null,
  idsFornecedorResponsavel: null,
  dataSolicitacaoDe: null,
  dataSolicitacaoAte: null,
  status: null,
}